import { multipartVoteApi } from './index';

/**
 * Submit user feedback.
 * @param {{ description: string, type: string, file?: File|null }} payload
 * @returns {Promise<any>}
 */
export const createFeedback = async ({ description, type, file }) => {
    const formData = new FormData();
    formData.append('Description', description);
    formData.append('Type', type);
    if (file) {
        formData.append('File', file);
    }
    const response = await multipartVoteApi.post('/Feedback/create', formData);
    return response.data;
};
